import { gql } from '@apollo/client'
import { ADMIN_STORE_HISTORY_FRAGMENT } from '../fragments/AdminStoreHistoryFragment'

export const GET_ADMIN_STORE_HISTORY = gql`
  query GetStoreHistory($input: StoreHistoryInput!) {
    storeHistory(input: $input) {
      hasMore
      count
      results {
        ...AdminStoreHistory
      }
    }
  }
  ${ADMIN_STORE_HISTORY_FRAGMENT}
`
